<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
      </div>
      <div
        style="padding: 20px 30px;"
        class="container-fluid mycontainer-fluid content"
      >
        <div style="width: 1100px">
          <table class="co-executor" v-if="recordsLoaded">
            <thead>
              <tr>
                <th>Институт развития*</th>
                <th>Форма участия в проекте*</th>
                <td></td>
              </tr>
            </thead>
            <tbody :disabled="!IS_EDIT_IR">
              <tr v-for="item in records">
                <td
                  v-bind:class="{
                    'has-error': item.HAS_IR_ERROR
                  }"
                  style="padding-right: 20px"
                >
                  <select
                    v-model="item.UF_IR_ID"
                    class="sel-dropdown i-main-style"
                    @change="updateItem(item)"
                    :disabled="!IS_EDIT_IR"
                  >
                    <option value=""></option>
                    <option
                      v-for="item in directory.ir_sp"
                      v-bind:value="item.ID"
                      v-bind:key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </td>
                <td
                  style="padding: 10px 0"
                  v-bind:class="{
                    'has-error': item.HAS_PART_ERROR
                  }"
                >
                  <textarea
                    @change="updateItem(item)"
                    v-model="item.UF_FORM_PART_PROJECT"
                    class="i-main-style t-co-executor-style"
                    :disabled="!IS_EDIT_IR"
                  ></textarea>
                </td>
                <td v-show="IS_EDIT_IR">
                  <a
                    @click="deleteItem(item.ID)"
                    class="link-delete-row"
                    :disabled="!IS_EDIT_IR"
                  ></a>
                </td>
              </tr>
              <tr v-if="records.length < 5" v-show="IS_EDIT_IR">
                <td colspan="3">
                  <div class="add-row">
                    <a
                      class="link-add-row"
                      v-on:click="addItem"
                      :disabled="!IS_EDIT_IR"
                      >Добавить ИР</a
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  FETCH_PROJECT,
  FETCH_DIRECTORY,
  SET_IS_VIEW_ALL_EXPERTISE
} from "../../store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import ProjectMenu from "@/components/project/partial/ProjectMenu";

Vue.filter("fileName", function(value) {
  let l = value.split("/");

  return l[l.length - 1];
});

export default {
  name: "Institutes",
  title: "Участие в проекте институтов развития",
  watch: {},
  computed: {
    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "currentUser",
      "notifications"
    ])
  },
  data() {
    return {
      recordsLoaded: true,
      records: [],
      siteUrl: "",
      IS_EDIT_IR: true
    };
  },
  components: {
    ProjectMenu,
    ProjectHeader
  },
  methods: {
    async fetchProject() {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);

      ProjectsService.getListIR(this.project.ID).then(response => {
        this.mapRecords(response.data.items);
      });
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    addItem() {
      ProjectsService.addIR(this.project.ID).then(() => {
        ProjectsService.getListIR(this.project.ID).then(response => {
          this.mapRecords(response.data.items);
        });
      }, this);
    },
    deleteItem(id) {
      ProjectsService.deleteIR(this.project.ID, id).then(() => {
        ProjectsService.getListIR(this.project.ID).then(response => {
          this.mapRecords(response.data.items);
        });
      }, this);
    },
    mapRecords(records) {
      this.records = [];
      records.forEach(function(r) {
        r.HAS_IR_ERROR = false;
        r.HAS_PART_ERROR = false;
        this.records.push(r);
      }, this);
    },
    updateItem(item) {
      let hasError = false;
      if (item.UF_FORM_PART_PROJECT === "") {
        item.HAS_PART_ERROR = true;
        hasError = true;
      } else {
        item.HAS_PART_ERROR = false;
      }
      if (!item.UF_IR_ID) {
        item.HAS_IR_ERROR = true;
        hasError = true;
      } else {
        item.HAS_IR_ERROR = false;
      }

      if (!hasError) {
        ProjectsService.updateIR(this.project.ID, item.ID, item).then(() => {
          ProjectsService.getListIR(this.project.ID).then(response => {
            this.records = response.data.items;
          });
        }, this);
      }
    }
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);
    await this.$store.dispatch(FETCH_DIRECTORY, ["ir_sp"]).then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
    }, this);
  },
  mounted() {
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
      data.IS_EDIT_IR === 1 && data.IS_EDIT_IR === 1
        ? (this.IS_EDIT_IR = true)
        : (this.IS_EDIT_IR = false);
    }, this);
  }
};
</script>

<style scoped></style>
